import { CountryCode, countryDefaultCode } from '@/i18n/countries';

const _legalInfo: Partial<Record<CountryCode, LegalInfo>> & { RS: LegalInfo } = {
    RS: {
        name: 'Polako Hedonist Belgrade',
        tax_num: '114165836',
        reg_num: '67370481',
        address: 'Jurija Gagarina br 231, lokal 329, Belgrade',
        phone: '381616074651',
    },
    RU: { name: 'ИП Дорошков Вадим Иванович', tax_num: '784390089111', phone: '79214453878' },
};

export const legalInfo = (countryCode?: CountryCode | string): LegalInfo =>
    _legalInfo[countryCode && countryCode in _legalInfo ? (countryCode as CountryCode) : countryDefaultCode]!;

interface LegalInfo {
    name: string;
    tax_num: string;
    reg_num?: string;
    address?: string;
    phone?: string;
}
